import { uniqBy } from 'lodash-es'
import { BaseQueryOptions } from '@apollo/client'

const makeLoadMore =
  (fetchMore: any, data: any, pathName: string) =>
  (options?: BaseQueryOptions<any>) => {
    if (!data[pathName]?.pageInfo?.hasNextPage) {
      return data
    }
    const isMobile = window.innerWidth <= 991

    const variables = {
      first: isMobile ? 10 : 20,
      after: data[pathName].pageInfo.endCursor,
      ...options,
    }

    return fetchMore({
      updateQuery: (
        previousResult: any,
        { fetchMoreResult }: { fetchMoreResult: any },
      ) => {
        if (!previousResult) {
          return {
            [pathName]: {
              edges: [],
              pageInfo: {
                startCursor: null,
                endCursor: null,
                hasNextPage: false,
              },
              totalCount: 0,
            },
          }
        }

        const { edges, pageInfo, totalCount } = fetchMoreResult[pathName]

        // If the query contains more calls then the pathName, we have to include them in the cache
        const { [pathName]: firstQueryResult, ...rest } = previousResult

        const mergedEdges = [
          ...(previousResult?.[pathName]?.edges ?? []),
          ...edges,
        ]

        const hasIdField = !!mergedEdges[0]?.node?.id

        return edges.length
          ? {
              [pathName]: {
                __typename: previousResult[pathName]?.__typename,
                edges: hasIdField
                  ? uniqBy(mergedEdges, 'node.id')
                  : mergedEdges,
                pageInfo,
                totalCount,
              },
              ...rest,
            }
          : previousResult[pathName]
      },
      variables,
    })
  }

export default makeLoadMore
